module.exports = __webpack_public_path__ + "static/media/telegram.deb1fa95.svg";